function dateFromNow(delta: number): string {
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return d.toISOString().slice(0, 10);
}

function isoFromNow(delta: number): string {
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return d.toISOString();
}

function monthFromNow(deltaMonths: number): string {
  const d = new Date();
  d.setMonth(d.getMonth() + deltaMonths);
  return d.toISOString().slice(0, 7);
}

export const mockAssignedCompanies = {
  data: [
    { companyId: 'cmp-1', name: 'Przykładowa Firma sp. z o.o.', nip: '5260001246' },
    { companyId: 'cmp-2', name: 'Beta Handel sp.j.', nip: '7792308508' },
  ],
};

interface EmployeeOverrides {
  id: string;
  firstName: string;
  lastName: string;
  position: string;
  email: string;
  pesel: string;
  hireOffset: number;
  status?: 'active' | 'inactive';
  terminationDate?: string;
  taxId?: string;
  phone?: string;
  addrStreet?: string;
  addrBuildingNo?: string;
  addrFlatNo?: string;
  addrCity?: string;
  addrPostcode?: string;
  taxOfficeCode?: string;
  pit2?: boolean;
  higherCosts?: boolean;
  contractCount?: number;
  absenceDays?: number;
  birthDate?: string;
  notes?: string;
}

function buildEmployee(opts: EmployeeOverrides) {
  const street = opts.addrStreet ?? 'Pracownicza';
  const buildingNo = opts.addrBuildingNo ?? '1';
  const flatNo = opts.addrFlatNo ?? '';
  const city = opts.addrCity ?? 'Warszawa';
  const postcode = opts.addrPostcode ?? '00-001';
  const address = `ul. ${street} ${buildingNo}${flatNo ? '/' + flatNo : ''}, ${postcode} ${city}`;
  return {
    id: opts.id,
    firstName: opts.firstName,
    lastName: opts.lastName,
    email: opts.email,
    phone: opts.phone ?? '+48 600 100 200',
    position: opts.position,
    pesel: opts.pesel,
    taxId: opts.taxId ?? '',
    address,
    hireDate: dateFromNow(opts.hireOffset),
    terminationDate: opts.terminationDate ?? '',
    status: opts.status ?? 'active',
    notes: opts.notes ?? '',
    birthDate: opts.birthDate ?? '1990-05-12',
    addrStreet: street,
    addrBuildingNo: buildingNo,
    addrFlatNo: flatNo,
    addrCity: city,
    addrPostcode: postcode,
    addrCountry: 'PL',
    taxOfficeCode: opts.taxOfficeCode ?? '1471',
    pit2: opts.pit2 ?? true,
    higherCosts: opts.higherCosts ?? false,
    contractCount: opts.contractCount ?? 1,
    absenceDays: opts.absenceDays ?? 0,
    createdAt: isoFromNow(opts.hireOffset),
    updatedAt: isoFromNow(-5),
  };
}

export const mockEmployees = [
  buildEmployee({
    id: 'emp-1', firstName: 'Jan', lastName: 'Kowalski', position: 'Programista',
    email: 'jan.kowalski@firma.pl', pesel: '90051212345', hireOffset: -400,
    addrStreet: 'Marszałkowska', addrBuildingNo: '12', addrFlatNo: '5', addrCity: 'Warszawa', addrPostcode: '00-590',
    contractCount: 1, absenceDays: 12, higherCosts: true, birthDate: '1990-05-12',
  }),
  buildEmployee({
    id: 'emp-2', firstName: 'Maria', lastName: 'Wiśniewska', position: 'Księgowa',
    email: 'maria.wisniewska@firma.pl', pesel: '88102298765', hireOffset: -220, phone: '+48 601 222 333',
    addrStreet: 'Długa', addrBuildingNo: '7', addrCity: 'Gdańsk', addrPostcode: '80-827',
    taxOfficeCode: '2261', contractCount: 1, absenceDays: 5, birthDate: '1988-10-22',
  }),
  buildEmployee({
    id: 'emp-3', firstName: 'Piotr', lastName: 'Nowak', position: 'Handlowiec',
    email: 'piotr.nowak@firma.pl', pesel: '85030445612', hireOffset: -140, phone: '+48 602 444 555',
    taxId: '7811234567', addrStreet: 'Półwiejska', addrBuildingNo: '23', addrCity: 'Poznań', addrPostcode: '61-888',
    taxOfficeCode: '3006', pit2: false, contractCount: 1, absenceDays: 3, birthDate: '1985-03-04',
    notes: 'Współpraca w modelu B2B, samozatrudnienie.',
  }),
  buildEmployee({
    id: 'emp-4', firstName: 'Anna', lastName: 'Zielińska', position: 'Specjalista ds. kadr',
    email: 'anna.zielinska@firma.pl', pesel: '93072855321', hireOffset: -75, phone: '+48 603 666 777',
    addrStreet: 'Floriańska', addrBuildingNo: '3', addrFlatNo: '2', addrCity: 'Kraków', addrPostcode: '31-019',
    taxOfficeCode: '1271', contractCount: 1, absenceDays: 0, higherCosts: true, birthDate: '1993-07-28',
  }),
  buildEmployee({
    id: 'emp-5', firstName: 'Tomasz', lastName: 'Lewandowski', position: 'Magazynier',
    email: 'tomasz.lewandowski@firma.pl', pesel: '79111067890', hireOffset: -900, phone: '+48 604 888 999',
    status: 'inactive', terminationDate: dateFromNow(-30),
    addrStreet: 'Piotrkowska', addrBuildingNo: '104', addrCity: 'Łódź', addrPostcode: '90-926',
    taxOfficeCode: '1005', contractCount: 1, absenceDays: 8, birthDate: '1979-11-10',
    notes: 'Umowa zakończona za porozumieniem stron.',
  }),
];

export const mockEmployeeList = { data: mockEmployees };

export function mockEmployeeById(id: string) {
  return mockEmployees.find((e) => e.id === id) ?? mockEmployees[0];
}

const contractsByEmployee: Record<string, unknown[]> = {
  'emp-1': [
    { id: 'ctr-1', employeeId: 'emp-1', type: 'uop', startDate: dateFromNow(-400), endDate: '', grossSalary: 12000, currency: 'PLN', weeklyHours: 40, status: 'active', notes: 'Pełny etat, czas nieokreślony.', insuranceTitleCode: '0110', sicknessVoluntary: true, createdAt: isoFromNow(-400), updatedAt: isoFromNow(-30) },
  ],
  'emp-2': [
    { id: 'ctr-2', employeeId: 'emp-2', type: 'uop', startDate: dateFromNow(-220), endDate: dateFromNow(500), grossSalary: 9500, currency: 'PLN', weeklyHours: 40, status: 'active', notes: 'Umowa na czas określony.', insuranceTitleCode: '0110', sicknessVoluntary: true, createdAt: isoFromNow(-220), updatedAt: isoFromNow(-60) },
    { id: 'ctr-2b', employeeId: 'emp-2', type: 'zlecenie', startDate: dateFromNow(-600), endDate: dateFromNow(-230), grossSalary: 3200, currency: 'PLN', weeklyHours: 20, status: 'terminated', notes: 'Poprzednia umowa zlecenie.', insuranceTitleCode: '0411', sicknessVoluntary: false, terminationMode: 'expiry', terminationReason: 'Upływ okresu, na jaki umowa została zawarta.', createdAt: isoFromNow(-600), updatedAt: isoFromNow(-230) },
  ],
  'emp-3': [
    { id: 'ctr-3', employeeId: 'emp-3', type: 'b2b', startDate: dateFromNow(-140), endDate: '', grossSalary: 18000, currency: 'PLN', weeklyHours: 40, status: 'active', notes: 'Kontrakt B2B, faktura miesięczna.', insuranceTitleCode: '0570', sicknessVoluntary: false, createdAt: isoFromNow(-140), updatedAt: isoFromNow(-14) },
  ],
  'emp-4': [
    { id: 'ctr-4', employeeId: 'emp-4', type: 'dzielo', startDate: dateFromNow(-75), endDate: dateFromNow(-10), grossSalary: 6000, currency: 'PLN', weeklyHours: 0, status: 'terminated', notes: 'Umowa o dzieło — projekt wdrożeniowy.', insuranceTitleCode: '', sicknessVoluntary: false, terminationMode: 'agreement', terminationReason: 'Zakończenie projektu — porozumienie stron.', createdAt: isoFromNow(-75), updatedAt: isoFromNow(-10) },
    { id: 'ctr-4b', employeeId: 'emp-4', type: 'uop', startDate: dateFromNow(-9), endDate: '', grossSalary: 8800, currency: 'PLN', weeklyHours: 40, status: 'active', notes: 'Przejście na etat po umowie o dzieło.', insuranceTitleCode: '0110', sicknessVoluntary: true, createdAt: isoFromNow(-9), updatedAt: isoFromNow(-2) },
  ],
  'emp-5': [
    { id: 'ctr-5', employeeId: 'emp-5', type: 'uop', startDate: dateFromNow(-900), endDate: dateFromNow(-30), grossSalary: 5200, currency: 'PLN', weeklyHours: 40, status: 'terminated', notes: 'Umowa rozwiązana.', insuranceTitleCode: '0110', sicknessVoluntary: true, terminationMode: 'notice', terminationReason: 'Wypowiedzenie przez pracownika z zachowaniem okresu wypowiedzenia.', createdAt: isoFromNow(-900), updatedAt: isoFromNow(-30) },
  ],
};

const absencesByEmployee: Record<string, unknown[]> = {
  'emp-1': [
    { id: 'abs-1', employeeId: 'emp-1', type: 'vacation', startDate: dateFromNow(2), endDate: dateFromNow(4), workingDays: 3, status: 'pending', notes: 'Urlop wypoczynkowy.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-1), updatedAt: isoFromNow(-1) },
    { id: 'abs-2', employeeId: 'emp-1', type: 'sick', startDate: dateFromNow(-20), endDate: dateFromNow(-16), workingDays: 5, status: 'approved', notes: 'Zwolnienie lekarskie L4.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-19), createdAt: isoFromNow(-21), updatedAt: isoFromNow(-19) },
    { id: 'abs-3', employeeId: 'emp-1', type: 'unpaid', startDate: dateFromNow(-60), endDate: dateFromNow(-59), workingDays: 2, status: 'rejected', notes: 'Wniosek odrzucony — brak zastępstwa.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-58), createdAt: isoFromNow(-62), updatedAt: isoFromNow(-58) },
  ],
  'emp-2': [
    { id: 'abs-4', employeeId: 'emp-2', type: 'vacation', startDate: dateFromNow(-10), endDate: dateFromNow(-6), workingDays: 5, status: 'approved', notes: 'Urlop wiosenny.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-14), createdAt: isoFromNow(-15), updatedAt: isoFromNow(-14) },
    { id: 'abs-5', employeeId: 'emp-2', type: 'other', startDate: dateFromNow(5), endDate: dateFromNow(5), workingDays: 1, status: 'pending', notes: 'Opieka nad dzieckiem.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-2), updatedAt: isoFromNow(-2) },
  ],
  'emp-3': [
    { id: 'abs-6', employeeId: 'emp-3', type: 'vacation', startDate: dateFromNow(14), endDate: dateFromNow(21), workingDays: 6, status: 'pending', notes: 'Planowany urlop.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-3), updatedAt: isoFromNow(-3) },
  ],
  'emp-4': [],
  'emp-5': [
    { id: 'abs-7', employeeId: 'emp-5', type: 'sick', startDate: dateFromNow(-45), endDate: dateFromNow(-38), workingDays: 6, status: 'approved', notes: 'L4 przed zakończeniem umowy.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-46), createdAt: isoFromNow(-47), updatedAt: isoFromNow(-46) },
  ],
};

const tripsByEmployee: Record<string, unknown[]> = {
  'emp-1': [
    { id: 'trip-1', employeeId: 'emp-1', destination: 'Kraków', purpose: 'Wdrożenie u klienta', startDate: dateFromNow(7), endDate: dateFromNow(8), days: 2, perDiem: 45, advance: 200, currency: 'PLN', status: 'planned', notes: 'Nocleg opłacony przez klienta.', approvedBy: '', approvedAt: '', rejectedBy: '', rejectedAt: '', actualCost: 0, settledAmount: 0, settlementCurrency: '', settlementNote: '', settledBy: '', settledAt: '', createdAt: isoFromNow(-2), updatedAt: isoFromNow(-2) },
    { id: 'trip-2', employeeId: 'emp-1', destination: 'Berlin', purpose: 'Konferencja branżowa', startDate: dateFromNow(-3), endDate: dateFromNow(-1), days: 3, perDiem: 49, advance: 500, currency: 'EUR', status: 'in_progress', notes: 'Delegacja zagraniczna.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-6), rejectedBy: '', rejectedAt: '', actualCost: 0, settledAmount: 0, settlementCurrency: '', settlementNote: '', settledBy: '', settledAt: '', createdAt: isoFromNow(-8), updatedAt: isoFromNow(-3) },
  ],
  'emp-2': [
    { id: 'trip-3', employeeId: 'emp-2', destination: 'Wrocław', purpose: 'Szkolenie księgowe', startDate: dateFromNow(-30), endDate: dateFromNow(-29), days: 2, perDiem: 45, advance: 150, currency: 'PLN', status: 'settled', notes: 'Rozliczono w poprzednim miesiącu.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-33), rejectedBy: '', rejectedAt: '', actualCost: 180, settledAmount: 30, settlementCurrency: 'PLN', settlementNote: 'Dodatkowy nocleg — dopłata do zaliczki.', settledBy: 'Agnieszka Kadrowa', settledAt: isoFromNow(-28), createdAt: isoFromNow(-35), updatedAt: isoFromNow(-28) },
    { id: 'trip-6', employeeId: 'emp-2', destination: 'Poznań', purpose: 'Audyt u kontrahenta', startDate: dateFromNow(10), endDate: dateFromNow(11), days: 2, perDiem: 45, advance: 250, currency: 'PLN', status: 'rejected', notes: 'Odrzucono — termin koliduje z zamknięciem miesiąca.', approvedBy: '', approvedAt: '', rejectedBy: 'Agnieszka Kadrowa', rejectedAt: isoFromNow(-1), actualCost: 0, settledAmount: 0, settlementCurrency: '', settlementNote: '', settledBy: '', settledAt: '', createdAt: isoFromNow(-2), updatedAt: isoFromNow(-1) },
  ],
  'emp-3': [
    { id: 'trip-4', employeeId: 'emp-3', destination: 'Gdańsk', purpose: 'Spotkanie handlowe', startDate: dateFromNow(3), endDate: dateFromNow(4), days: 2, perDiem: 45, advance: 300, currency: 'PLN', status: 'planned', notes: '', approvedBy: '', approvedAt: '', rejectedBy: '', rejectedAt: '', actualCost: 0, settledAmount: 0, settlementCurrency: '', settlementNote: '', settledBy: '', settledAt: '', createdAt: isoFromNow(-1), updatedAt: isoFromNow(-1) },
    { id: 'trip-5', employeeId: 'emp-3', destination: 'Katowice', purpose: 'Targi branżowe', startDate: dateFromNow(-15), endDate: dateFromNow(-13), days: 3, perDiem: 45, advance: 400, currency: 'PLN', status: 'settled', notes: 'Rozliczone.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-18), rejectedBy: '', rejectedAt: '', actualCost: 360, settledAmount: -40, settlementCurrency: 'PLN', settlementNote: 'Zwrot niewykorzystanej zaliczki.', settledBy: 'Agnieszka Kadrowa', settledAt: isoFromNow(-12), createdAt: isoFromNow(-20), updatedAt: isoFromNow(-12) },
  ],
  'emp-4': [
    { id: 'trip-7', employeeId: 'emp-4', destination: 'Łódź', purpose: 'Szkolenie kadrowe', startDate: dateFromNow(-5), endDate: dateFromNow(-4), days: 2, perDiem: 45, advance: 200, currency: 'PLN', status: 'in_progress', notes: 'Delegacja w toku — do rozliczenia.', approvedBy: 'Agnieszka Kadrowa', approvedAt: isoFromNow(-7), rejectedBy: '', rejectedAt: '', actualCost: 0, settledAmount: 0, settlementCurrency: '', settlementNote: '', settledBy: '', settledAt: '', createdAt: isoFromNow(-9), updatedAt: isoFromNow(-6) },
  ],
  'emp-5': [],
};

const documentsByEmployee: Record<string, unknown[]> = {
  'emp-1': [
    { id: 'doc-1', employeeId: 'emp-1', name: 'Umowa o pracę', docType: 'contract', filename: 'umowa-kowalski.pdf', contentType: 'application/pdf', sizeBytes: 184320, createdAt: isoFromNow(-400) },
    { id: 'doc-2', employeeId: 'emp-1', name: 'Zaświadczenie o zatrudnieniu', docType: 'certificate', filename: 'zaswiadczenie-kowalski.pdf', contentType: 'application/pdf', sizeBytes: 92160, createdAt: isoFromNow(-30) },
    { id: 'doc-3', employeeId: 'emp-1', name: 'Badania lekarskie', docType: 'medical', filename: 'badania-kowalski.pdf', contentType: 'application/pdf', sizeBytes: 61440, createdAt: isoFromNow(-380) },
  ],
  'emp-2': [
    { id: 'doc-4', employeeId: 'emp-2', name: 'Umowa o pracę', docType: 'contract', filename: 'umowa-wisniewska.pdf', contentType: 'application/pdf', sizeBytes: 176128, createdAt: isoFromNow(-220) },
    { id: 'doc-5', employeeId: 'emp-2', name: 'Skan dowodu osobistego', docType: 'id', filename: 'dowod-wisniewska.jpg', contentType: 'image/jpeg', sizeBytes: 245760, createdAt: isoFromNow(-219) },
  ],
  'emp-3': [
    { id: 'doc-6', employeeId: 'emp-3', name: 'Umowa B2B', docType: 'contract', filename: 'umowa-b2b-nowak.pdf', contentType: 'application/pdf', sizeBytes: 210944, createdAt: isoFromNow(-140) },
    { id: 'doc-7', employeeId: 'emp-3', name: 'Wpis CEIDG', docType: 'other', filename: 'ceidg-nowak.pdf', contentType: 'application/pdf', sizeBytes: 71680, createdAt: isoFromNow(-139) },
  ],
  'emp-4': [
    { id: 'doc-8', employeeId: 'emp-4', name: 'Umowa o dzieło', docType: 'contract', filename: 'umowa-dzielo-zielinska.pdf', contentType: 'application/pdf', sizeBytes: 133120, createdAt: isoFromNow(-75) },
  ],
  'emp-5': [
    { id: 'doc-9', employeeId: 'emp-5', name: 'Świadectwo pracy', docType: 'certificate', filename: 'swiadectwo-lewandowski.pdf', contentType: 'application/pdf', sizeBytes: 98304, createdAt: isoFromNow(-30) },
  ],
};

function buildTimeEntries(employeeId: string, prefix: string, spec: { d: number; h: number; t: string; desc?: string }[]) {
  return spec.map((s, i) => ({
    id: `${prefix}-${i + 1}`,
    employeeId,
    workDate: dateFromNow(s.d),
    hours: s.h,
    entryType: s.t,
    description: s.desc ?? '',
    createdAt: isoFromNow(s.d),
    updatedAt: isoFromNow(s.d),
  }));
}

const timeEntriesByEmployee: Record<string, unknown[]> = {
  'emp-1': buildTimeEntries('emp-1', 'te1', [
    { d: -1, h: 8, t: 'work' },
    { d: -2, h: 8, t: 'work' },
    { d: -3, h: 10, t: 'overtime', desc: 'Wdrożenie na produkcję.' },
    { d: -4, h: 8, t: 'remote', desc: 'Praca zdalna.' },
    { d: -5, h: 8, t: 'work' },
    { d: -8, h: 8, t: 'work' },
    { d: -9, h: 8, t: 'remote' },
    { d: -10, h: 6, t: 'work' },
    { d: -11, h: 9, t: 'overtime' },
    { d: -12, h: 8, t: 'work' },
  ]),
  'emp-2': buildTimeEntries('emp-2', 'te2', [
    { d: -1, h: 8, t: 'work' },
    { d: -2, h: 8, t: 'work' },
    { d: -3, h: 8, t: 'remote', desc: 'Zamknięcie miesiąca.' },
    { d: -4, h: 8, t: 'work' },
    { d: -5, h: 4, t: 'work' },
  ]),
  'emp-3': buildTimeEntries('emp-3', 'te3', [
    { d: -1, h: 8, t: 'work' },
    { d: -2, h: 8, t: 'remote' },
    { d: -3, h: 8, t: 'work' },
  ]),
  'emp-4': [],
  'emp-5': [],
};

export function mockContractsByEmployee(id: string) {
  return { data: contractsByEmployee[id] ?? [] };
}

function findContract(employeeId: string, contractId: string): Record<string, unknown> | undefined {
  return (contractsByEmployee[employeeId] as Record<string, unknown>[] | undefined)?.find((c) => c['id'] === contractId);
}

export function mockTerminateContract(employeeId: string, contractId: string, body: unknown) {
  const contract = findContract(employeeId, contractId);
  const payload = (body ?? {}) as { terminationDate?: string; mode?: string; reason?: string };
  return {
    ...(contract ?? { id: contractId, employeeId }),
    status: 'terminated',
    endDate: payload.terminationDate || (contract?.['endDate'] as string) || dateFromNow(0),
    terminationMode: payload.mode || 'notice',
    terminationReason: payload.reason ?? '',
    updatedAt: isoFromNow(0),
  };
}

function docHtml(title: string, sections: [string, string][]): string {
  const rows = sections
    .map(([k, v]) => `<tr><td class="k">${k}</td><td class="v">${v || '—'}</td></tr>`)
    .join('');
  return `<!doctype html><html lang="pl"><head><meta charset="utf-8"><title>${title}</title>
<style>body{font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#1f2937;padding:32px;background:#f8fafc}
.sheet{max-width:720px;margin:0 auto;background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:32px}
h1{font-size:22px;text-align:center}table{width:100%;border-collapse:collapse}
td{padding:7px 8px;border-bottom:1px solid #f1f5f9;font-size:14px}td.k{color:#64748b;width:42%}td.v{font-weight:600}
</style></head><body><div class="sheet"><h1>${title}</h1><table>${rows}</table></div></body></html>`;
}

export function mockContractDocumentHtml(employeeId: string, contractId: string): string {
  const c = findContract(employeeId, contractId) ?? {};
  const emp = mockEmployeeById(employeeId);
  return docHtml('Umowa o pracę', [
    ['Pracownik', `${emp.firstName} ${emp.lastName}`],
    ['Stanowisko', String(emp.position ?? '')],
    ['Rodzaj umowy', String(c['type'] ?? 'uop')],
    ['Data rozpoczęcia', String(c['startDate'] ?? '')],
    ['Data zakończenia', String(c['endDate'] ?? 'czas nieokreślony')],
    ['Wynagrodzenie brutto', `${c['grossSalary'] ?? 0} ${c['currency'] ?? 'PLN'}`],
    ['Godziny tygodniowo', String(c['weeklyHours'] ?? 0)],
    ['Kod tytułu ubezpieczenia ZUS', String(c['insuranceTitleCode'] ?? '')],
  ]);
}

export function mockCertificateHtml(employeeId: string, contractId: string): string {
  const c = findContract(employeeId, contractId) ?? {};
  const emp = mockEmployeeById(employeeId);
  return docHtml('Świadectwo pracy', [
    ['Pracownik', `${emp.firstName} ${emp.lastName}`],
    ['Stanowisko', String(emp.position ?? '')],
    ['Zatrudniony od', String(c['startDate'] ?? emp.hireDate ?? '')],
    ['Zatrudniony do', String(c['endDate'] ?? emp.terminationDate ?? '')],
    ['Tryb rozwiązania', String(c['terminationMode'] ?? '')],
    ['Podstawa / uzasadnienie', String(c['terminationReason'] ?? '')],
  ]);
}

export function mockAbsencesByEmployee(id: string) {
  return { data: absencesByEmployee[id] ?? [] };
}

export function mockTripsByEmployee(id: string) {
  return { data: tripsByEmployee[id] ?? [] };
}

function findTrip(employeeId: string, tripId: string): Record<string, unknown> | undefined {
  return (tripsByEmployee[employeeId] as Record<string, unknown>[] | undefined)?.find((t) => t['id'] === tripId);
}

export function mockRejectTrip(employeeId: string, tripId: string) {
  const trip = findTrip(employeeId, tripId);
  return {
    ...(trip ?? { id: tripId, employeeId }),
    status: 'rejected',
    rejectedBy: 'Agnieszka Kadrowa',
    rejectedAt: isoFromNow(0),
    updatedAt: isoFromNow(0),
  };
}

export function mockSettleTrip(employeeId: string, tripId: string, body: unknown) {
  const trip = findTrip(employeeId, tripId);
  const advance = Number((trip?.['advance'] as number) ?? 0);
  const payload = (body ?? {}) as { actualCost?: number; currency?: string; note?: string };
  const actualCost = Number(payload.actualCost ?? 0);
  const currency = payload.currency || (trip?.['currency'] as string) || 'PLN';
  return {
    ...(trip ?? { id: tripId, employeeId }),
    status: 'settled',
    actualCost,
    settledAmount: Math.round((actualCost - advance) * 100) / 100,
    settlementCurrency: currency,
    settlementNote: payload.note ?? '',
    settledBy: 'Agnieszka Kadrowa',
    settledAt: isoFromNow(0),
    updatedAt: isoFromNow(0),
  };
}

export function mockDocumentsByEmployee(id: string) {
  return { data: documentsByEmployee[id] ?? [] };
}

export function mockTimeEntriesByEmployee(id: string) {
  return { data: timeEntriesByEmployee[id] ?? [] };
}

export const mockContracts = mockContractsByEmployee('emp-1');
export const mockAbsences = mockAbsencesByEmployee('emp-1');
export const mockTrips = mockTripsByEmployee('emp-1');
export const mockDocuments = mockDocumentsByEmployee('emp-1');
export const mockTimeEntries = mockTimeEntriesByEmployee('emp-1');

export const mockPayroll = {
  period: monthFromNow(0),
  status: 'open',
  rows: [
    { employeeId: 'emp-1', employeeName: 'Jan Kowalski', position: 'Programista', contractType: 'uop', contractCount: 1, grossSalary: 12000, employerContributions: 2455.2, employerCost: 14455.2, pensionEmployee: 1171.2, disabilityEmployee: 180, sicknessEmployee: 294, employeeSocial: 1645.2, health: 931.93, kup: 250, taxBase: 10105, pitAdvance: 913, net: 8509.87, currency: 'PLN' },
    { employeeId: 'emp-2', employeeName: 'Maria Wiśniewska', position: 'Księgowa', contractType: 'uop', contractCount: 1, grossSalary: 9500, employerContributions: 1943.7, employerCost: 11443.7, pensionEmployee: 927.2, disabilityEmployee: 142.5, sicknessEmployee: 232.75, employeeSocial: 1302.45, health: 737.78, kup: 250, taxBase: 7948, pitAdvance: 654, net: 6805.77, currency: 'PLN' },
    { employeeId: 'emp-4', employeeName: 'Anna Zielińska', position: 'Specjalista ds. kadr', contractType: 'uop', contractCount: 1, grossSalary: 8800, employerContributions: 1800.48, employerCost: 10600.48, pensionEmployee: 858.88, disabilityEmployee: 132, sicknessEmployee: 215.6, employeeSocial: 1206.48, health: 683.42, kup: 250, taxBase: 7344, pitAdvance: 581, net: 6329.1, currency: 'PLN' },
    { employeeId: 'emp-6', employeeName: 'Katarzyna Wójcik', position: 'Grafik', contractType: 'zlecenie', contractCount: 1, grossSalary: 4200, employerContributions: 859.32, employerCost: 5059.32, pensionEmployee: 409.92, disabilityEmployee: 63, sicknessEmployee: 102.9, employeeSocial: 575.82, health: 326.18, kup: 724.84, taxBase: 2899, pitAdvance: 348, net: 2950, currency: 'PLN' },
    { employeeId: 'emp-3', employeeName: 'Piotr Nowak', position: 'Handlowiec', contractType: 'b2b', contractCount: 1, grossSalary: 18000, employerContributions: 0, employerCost: 18000, pensionEmployee: 0, disabilityEmployee: 0, sicknessEmployee: 0, employeeSocial: 0, health: 0, kup: 0, taxBase: 0, pitAdvance: 0, net: 18000, currency: 'PLN' },
  ],
  totals: [
    { currency: 'PLN', gross: 52500, employerCost: 59558.7, net: 42594.74 },
  ],
};

export const mockPayrollPeriods = [
  { period: monthFromNow(0), status: 'open', lockedBy: '', lockedAt: '', paidAt: '', paidRef: '' },
  { period: monthFromNow(-1), status: 'locked', lockedBy: 'Agnieszka Kadrowa', lockedAt: isoFromNow(-2), paidAt: '', paidRef: '' },
  { period: monthFromNow(-2), status: 'paid', lockedBy: 'Agnieszka Kadrowa', lockedAt: isoFromNow(-33), paidAt: isoFromNow(-31), paidRef: 'PRZELEW/2026/05' },
];

export function mockPayrollPeriod(period: string) {
  return (
    mockPayrollPeriods.find((p) => p.period === period) ?? {
      period,
      status: 'open',
      lockedBy: '',
      lockedAt: '',
      paidAt: '',
      paidRef: '',
    }
  );
}

export function mockPayslipHtml(period: string): string {
  return [
    '<!doctype html><html lang="pl"><head><meta charset="utf-8">',
    `<title>Pasek wynagrodzenia ${period}</title></head><body>`,
    '<h1>Pasek wynagrodzenia</h1>',
    `<p>Okres: ${period}</p>`,
    '<p>Jan Kowalski · Programista</p>',
    '<table><tr><td>Wynagrodzenie brutto</td><td>12000.00 zł</td></tr>',
    '<tr><td>Razem składki społeczne</td><td>1645.20 zł</td></tr>',
    '<tr><td>Składka zdrowotna</td><td>931.93 zł</td></tr>',
    '<tr><td>Zaliczka na podatek (PIT)</td><td>913.00 zł</td></tr></table>',
    '<p><strong>Do wypłaty (netto): 8509.87 zł</strong></p>',
    '</body></html>',
  ].join('\n');
}

export function mockTransfersCsv(period: string): string {
  const title = `Wynagrodzenie ${period.slice(5)}/${period.slice(0, 4)}`;
  return [
    'Pracownik;Numer konta;Kwota netto;Tytuł',
    `Jan Kowalski;;8509.87;${title}`,
    `Maria Wiśniewska;;6805.77;${title}`,
    `Anna Zielińska;;6329.10;${title}`,
    `Katarzyna Wójcik;;2950.00;${title}`,
    `Piotr Nowak;;18000.00;${title}`,
  ].join('\r\n');
}

export const mockPayerSettings = {
  accidentRate: 1.67,
  fpApplicable: true,
  fgspApplicable: true,
  zusPayerId: '5260001246',
};

export const mockTaxSettlements = {
  data: [
    { taxType: 'ZUS', period: monthFromNow(0), amount: 7058.7, currency: 'PLN', note: 'Deklaracja bieżąca — zamknięta.', closedBy: 'Agnieszka Kadrowa', closedAt: isoFromNow(-1) },
    { taxType: 'ZUS', period: monthFromNow(-1), amount: 6890.4, currency: 'PLN', note: '', closedBy: 'Agnieszka Kadrowa', closedAt: isoFromNow(-31) },
    { taxType: 'ZUS', period: monthFromNow(-2), amount: 6712.15, currency: 'PLN', note: '', closedBy: 'Agnieszka Kadrowa', closedAt: isoFromNow(-61) },
  ],
};

export const mockPendingApprovals = {
  data: [
    { id: 'abs-1', employeeId: 'emp-1', employeeName: 'Jan Kowalski', type: 'vacation', startDate: dateFromNow(2), endDate: dateFromNow(4), workingDays: 3, status: 'pending', notes: 'Urlop wypoczynkowy.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-1), updatedAt: isoFromNow(-1) },
    { id: 'abs-5', employeeId: 'emp-2', employeeName: 'Maria Wiśniewska', type: 'other', startDate: dateFromNow(5), endDate: dateFromNow(5), workingDays: 1, status: 'pending', notes: 'Opieka nad dzieckiem.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-2), updatedAt: isoFromNow(-2) },
    { id: 'abs-6', employeeId: 'emp-3', employeeName: 'Piotr Nowak', type: 'vacation', startDate: dateFromNow(14), endDate: dateFromNow(21), workingDays: 6, status: 'pending', notes: 'Planowany urlop.', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-3), updatedAt: isoFromNow(-3) },
  ],
};

export const mockPendingTrips = {
  data: [
    { id: 'trip-1', employeeId: 'emp-1', employeeName: 'Jan Kowalski', destination: 'Kraków', purpose: 'Wdrożenie u klienta', startDate: dateFromNow(7), endDate: dateFromNow(8), days: 2, perDiem: 45, advance: 200, currency: 'PLN', status: 'planned', notes: '', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-2), updatedAt: isoFromNow(-2) },
    { id: 'trip-4', employeeId: 'emp-3', employeeName: 'Piotr Nowak', destination: 'Gdańsk', purpose: 'Spotkanie handlowe', startDate: dateFromNow(3), endDate: dateFromNow(4), days: 2, perDiem: 45, advance: 300, currency: 'PLN', status: 'planned', notes: '', approvedBy: '', approvedAt: '', createdAt: isoFromNow(-1), updatedAt: isoFromNow(-1) },
  ],
};

export const mockSummary = {
  employeesTotal: mockEmployees.length,
  employeesActive: mockEmployees.filter((e) => e.status === 'active').length,
  contractsActive: 4,
  absencesPending: mockPendingApprovals.data.length,
  tripsPending: mockPendingTrips.data.length,
  absenceDaysThisMonth: 8,
};

export const mockSupportTickets = {
  data: [
    { id: 'tic-1', subject: 'Pytanie o eksport PIT-11', category: 'question', status: 'open', lastMessage: 'Czy eksport obejmuje wszystkich pracowników?', lastMessageAt: isoFromNow(-1), unreadCount: 1, createdAt: isoFromNow(-3), updatedAt: isoFromNow(-1) },
    { id: 'tic-2', subject: 'Błąd przy zamykaniu ZUS', category: 'bug', status: 'in_progress', lastMessage: 'Analizujemy zgłoszenie, wrócimy z odpowiedzią.', lastMessageAt: isoFromNow(-2), unreadCount: 0, createdAt: isoFromNow(-6), updatedAt: isoFromNow(-2) },
    { id: 'tic-3', subject: 'Faktura za pakiet Premium', category: 'billing', status: 'waiting', lastMessage: 'Czekamy na potwierdzenie płatności.', lastMessageAt: isoFromNow(-4), unreadCount: 0, createdAt: isoFromNow(-10), updatedAt: isoFromNow(-4) },
    { id: 'tic-4', subject: 'Propozycja: masowy import RCP', category: 'feature', status: 'resolved', lastMessage: 'Dodaliśmy funkcję do najbliższego wydania.', lastMessageAt: isoFromNow(-8), unreadCount: 0, createdAt: isoFromNow(-20), updatedAt: isoFromNow(-8) },
    { id: 'tic-5', subject: 'Zmiana danych firmy', category: 'other', status: 'closed', lastMessage: 'Zgłoszenie zamknięte.', lastMessageAt: isoFromNow(-15), unreadCount: 0, createdAt: isoFromNow(-25), updatedAt: isoFromNow(-15) },
  ],
};

const ticketDetails: Record<string, unknown> = {
  'tic-1': {
    id: 'tic-1', subject: 'Pytanie o eksport PIT-11', category: 'question', status: 'open',
    messages: [
      { id: 'msg-1', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Czy eksport PIT-11 obejmuje wszystkich pracowników w firmie?', readAt: isoFromNow(-2), createdAt: isoFromNow(-3), mine: true },
      { id: 'msg-2', authorType: 'support', authorId: 'sup-1', authorName: 'Zespół wsparcia', body: 'Tak, eksport generuje pliki dla wszystkich aktywnych pracowników za wybrany rok.', readAt: isoFromNow(-1), createdAt: isoFromNow(-2), mine: false },
      { id: 'msg-3', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Dziękuję, a czy mogę wyeksportować pojedynczego pracownika?', createdAt: isoFromNow(-1), mine: true },
    ],
  },
  'tic-2': {
    id: 'tic-2', subject: 'Błąd przy zamykaniu ZUS', category: 'bug', status: 'in_progress',
    messages: [
      { id: 'msg-4', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Przy próbie zamknięcia deklaracji ZUS pojawia się komunikat o błędzie.', readAt: isoFromNow(-5), createdAt: isoFromNow(-6), mine: true },
      { id: 'msg-5', authorType: 'support', authorId: 'sup-2', authorName: 'Zespół wsparcia', body: 'Dziękujemy za zgłoszenie, analizujemy problem i wrócimy z odpowiedzią.', readAt: isoFromNow(-2), createdAt: isoFromNow(-2), mine: false },
    ],
  },
  'tic-3': {
    id: 'tic-3', subject: 'Faktura za pakiet Premium', category: 'billing', status: 'waiting',
    messages: [
      { id: 'msg-6', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Proszę o fakturę za pakiet Premium.', readAt: isoFromNow(-9), createdAt: isoFromNow(-10), mine: true },
      { id: 'msg-7', authorType: 'support', authorId: 'sup-1', authorName: 'Zespół wsparcia', body: 'Czekamy na potwierdzenie płatności, faktura zostanie wystawiona automatycznie.', readAt: isoFromNow(-4), createdAt: isoFromNow(-4), mine: false },
    ],
  },
  'tic-4': {
    id: 'tic-4', subject: 'Propozycja: masowy import RCP', category: 'feature', status: 'resolved',
    messages: [
      { id: 'msg-8', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Czy planujecie import RCP z pliku CSV?', readAt: isoFromNow(-19), createdAt: isoFromNow(-20), mine: true },
      { id: 'msg-9', authorType: 'support', authorId: 'sup-3', authorName: 'Zespół wsparcia', body: 'Funkcja została dodana do najbliższego wydania. Dziękujemy za sugestię!', readAt: isoFromNow(-8), createdAt: isoFromNow(-8), mine: false },
    ],
  },
  'tic-5': {
    id: 'tic-5', subject: 'Zmiana danych firmy', category: 'other', status: 'closed',
    messages: [
      { id: 'msg-10', authorType: 'user', authorId: 'hr-staff-1', authorName: 'Agnieszka Kadrowa', body: 'Zmieniliśmy adres siedziby, proszę o aktualizację.', readAt: isoFromNow(-24), createdAt: isoFromNow(-25), mine: true },
      { id: 'msg-11', authorType: 'support', authorId: 'sup-2', authorName: 'Zespół wsparcia', body: 'Dane zostały zaktualizowane. Zgłoszenie zamykamy.', readAt: isoFromNow(-15), createdAt: isoFromNow(-15), mine: false },
    ],
  },
};

export function mockTicketDetail(id: string) {
  return (
    ticketDetails[id] ?? {
      id,
      subject: 'Zgłoszenie',
      category: 'other',
      status: 'open',
      messages: [],
    }
  );
}

export function mockPit11Xml(): string {
  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<Deklaracja xmlns="http://crd.gov.pl/wzor/2023/12/13/13011/">',
    '  <Naglowek><KodFormularza>PIT-11</KodFormularza><WariantFormularza>29</WariantFormularza><Rok>2026</Rok></Naglowek>',
    '  <Podmiot1><NIP>5260001246</NIP><PelnaNazwa>Przykładowa Firma sp. z o.o.</PelnaNazwa></Podmiot1>',
    '  <Pozycje><PrzychodBrutto>144000.00</PrzychodBrutto><ZaliczkaPodatku>18240.00</ZaliczkaPodatku></Pozycje>',
    '</Deklaracja>',
  ].join('\n');
}

export function mockKeduXml(): string {
  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<KEDU xmlns="http://www.zus.pl/2022/KEDU_5_5">',
    '  <ZUSDRA><Naglowek><TypDokumentu>DRA</TypDokumentu><Okres>2026-06</Okres></Naglowek>',
    '    <ZadeklarowanaKwota>7058.70</ZadeklarowanaKwota></ZUSDRA>',
    '  <ZUSRCA id_dokumentu="2">',
    '    <I><p1><p1>01</p1><p2>2026-06</p2></p1></I>',
    '    <III id_bloku="1">',
    '      <A><p1>Kowalski</p1><p2>Jan</p2><p3>1</p3><p4>44051401458</p4></A>',
    '      <B><p1><p1>0110</p1><p2>0</p2><p3>0</p3></p1><p2>0</p2>',
    '        <p4>8000.00</p4><p5>8000.00</p5><p6>8000.00</p6>',
    '        <p7>780.80</p7><p8>780.80</p8><p10>120.00</p10><p11>520.00</p11>',
    '        <p13>196.00</p13><p14>133.60</p14><p26>6903.20</p26><p27>621.29</p27></B>',
    '    </III>',
    '  </ZUSRCA>',
    '</KEDU>',
  ].join('\n');
}

export function mockPit4rXml(year: number): string {
  const months = [
    ['P_31', 1250.0],
    ['P_32', 1250.0],
    ['P_33', 1310.0],
    ['P_34', 1310.0],
    ['P_35', 1310.0],
    ['P_36', 1360.0],
    ['P_37', 1360.0],
    ['P_38', 1360.0],
    ['P_39', 1420.0],
    ['P_40', 1420.0],
    ['P_41', 1420.0],
    ['P_42', 1480.0],
  ] as const;
  const total = months.reduce((sum, [, kwota]) => sum + kwota, 0);
  const rows = months
    .map(
      ([poz, kwota]) =>
        `    <Miesiac poz="${poz}"><LiczbaPodatnikow>4</LiczbaPodatnikow><NaleznaZaliczka>${kwota.toFixed(2)}</NaleznaZaliczka></Miesiac>`,
    )
    .join('\n');
  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<Deklaracja xmlns="http://crd.gov.pl/wzor/2022/12/06/12063/">',
    '  <Naglowek>',
    '    <KodFormularza kodSystemowy="PIT-4R (12)" kodPodatku="PIT" wersjaSchemy="1-0E">PIT-4R</KodFormularza>',
    '    <WariantFormularza>12</WariantFormularza>',
    '    <CelZlozenia poz="P_6">1</CelZlozenia>',
    `    <Rok>${year}</Rok>`,
    '    <KodUrzedu>1471</KodUrzedu>',
    '  </Naglowek>',
    '  <Podmiot1 rola="Płatnik">',
    '    <OsobaNiefizyczna><NIP>5260001246</NIP><PelnaNazwa>Przykładowa Firma sp. z o.o.</PelnaNazwa></OsobaNiefizyczna>',
    '  </Podmiot1>',
    '  <PozycjeSzczegolowe>',
    rows,
    '    <LiczbaPodatnikowRok>4</LiczbaPodatnikowRok>',
    `    <SumaNaleznychZaliczek>${total.toFixed(2)}</SumaNaleznychZaliczek>`,
    `    <KwotaDoWplaty>${total.toFixed(2)}</KwotaDoWplaty>`,
    '  </PozycjeSzczegolowe>',
    '  <Pouczenia>1</Pouczenia>',
    '</Deklaracja>',
  ].join('\n');
}

export function mockPit11BatchZip(): Blob {
  const header = 'PK';
  const note =
    'PIT-11 zbiorczy (demo) — w trybie mock archiwum ZIP jest zastępcze. W środowisku produkcyjnym zawiera po jednej deklaracji PIT-11 XML na każdego aktywnego pracownika (np. pit11-2026-kowalski-jan.xml).';
  return new Blob([header, note], { type: 'application/zip' });
}

export function mockKeycloakToken(): Record<string, unknown> {
  const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = btoa(
    JSON.stringify({
      sub: 'hr-staff-1',
      email: 'kadry@biuro-kadr.pl',
      preferred_username: 'kadry@biuro-kadr.pl',
      given_name: 'Agnieszka',
      realm_access: { roles: ['hr'] },
      exp: Math.floor(Date.now() / 1000) + 3600,
    }),
  );
  return {
    access_token: `${header}.${payload}.mock-signature`,
    refresh_token: 'mock-refresh-token',
    token_type: 'Bearer',
    expires_in: 1800,
    refresh_expires_in: 3600,
    scope: 'openid',
  };
}

/**
 * Faktury kosztowe pracownika na kontrakcie B2B. Dopasowanie po NIP-ie robi w produkcji
 * hr-gateway — tutaj odwzorowujemy sam wynik: faktury tylko tego pracownika.
 */
export function mockB2BInvoicesByEmployee(employeeId: string) {
  const employee = mockEmployees.find((e) => e.id === employeeId);
  const nip = (employee?.taxId ?? '').replace(/\D/g, '');
  if (!nip) {
    return { data: [] };
  }
  return {
    data: [
      {
        id: `ksef-${employeeId}-1`,
        number: 'FZ/2026/08/17',
        issueDate: dateFromNow(-12),
        sellerName: `${employee?.firstName ?? ''} ${employee?.lastName ?? ''}`.trim(),
        sellerNip: nip,
        grossTotal: 22140,
        currencyCode: 'PLN',
      },
      {
        id: `ksef-${employeeId}-2`,
        number: 'FZ/2026/07/09',
        issueDate: dateFromNow(-42),
        sellerName: `${employee?.firstName ?? ''} ${employee?.lastName ?? ''}`.trim(),
        sellerNip: nip,
        grossTotal: 22140,
        currencyCode: 'PLN',
      },
    ],
  };
}
